/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeProvider as AudiPlatformProvider } from '@oneaudi/unified-web-common';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import type { DealerContextServiceV1, UnsubscribeFn } from '@oneaudi/dealer-context-service';
import { GfaServiceConfigProviderV1 } from '@volkswagen-onehub/gfa-service-config-provider';
import {
  ContentServiceV1 as ContentService,
  ContentChangeListener,
} from '@volkswagen-onehub/audi-content-service';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { COLORS } from './styles/variables';
import GlobalStyles from './styles';
// import type { TrackingServiceV2 } from '@volkswagen-onehub/audi-tracking-service';
// import { createTrackingService } from '@volkswagen-onehub/oneaudi-os-adapter-tracking';
import ErrorBoundary from './components/ErrorBoundary';
import i18n from '../i18n';
import ContentWrapper from './components/ContentWrapper';
import { setDealerContext } from './reducers/dealerContextReducer';
import { AppContent, mapContent } from './components/contentMapping/contentMapping';
import { setConfig } from './reducers/appConfigReducer';
import { PARTNER_ID } from './constants/locationConstants';
import { ConfigTypes } from './types';

const apolloClient = new ApolloClient({
  uri: process.env.GRAPHQL_GATEWAY ?? '',
  cache: new InMemoryCache(),
});

export type ContentProps = {
  isHidden?: boolean;
};
interface FeatureAppProps {
  configProvider: GfaServiceConfigProviderV1;
  dealerContextService: DealerContextServiceV1;
  contentService?: ContentService;
  content?: ContentProps;
  remoteConfig: ConfigTypes;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
}

const FeatureApp: React.FC<FeatureAppProps> = ({
  dealerContextService,
  contentService,
  remoteConfig,
  ...inherited
}: FeatureAppProps) => {
  const dispatch = useDispatch();

  // const [rawContent, setRawContent] = useState(contentService?.getContent() as AppContent);

  // React.useEffect(() => {
  //   // eslint-disable-next-line no-param-reassign
  //   trackingService.featureAppName = __FEATURE_APP_NAME__;
  //   const readyEvent = {
  //     event: {
  //       attributes: {
  //         componentName: __FEATURE_APP_NAME__,
  //         elementName: '',
  //         label: '',
  //         clickID: '',
  //         pos: '',
  //         targetURL: '',
  //         value: '',
  //       },
  //       eventInfo: {
  //         eventAction: 'feature_app_ready',
  //         eventName: `${__FEATURE_APP_NAME__} - Feature App ready`,
  //       },
  //     },
  //   };
  //   trackingService.track(readyEvent);
  // }, []);

  // const content = mapContent(rawContent);
  // contentService?.onContentChange(setRawContent as ContentChangeListener);

  useEffect(() => {
    if (PARTNER_ID) {
      dispatch(setDealerContext({ dealerContextId: PARTNER_ID, dealerMarket: 'USA' }));
    }
    const unsubscribeDealerContext: UnsubscribeFn = dealerContextService?.subscribe(
      (dealerContext) => {
        if (dealerContext) {
          const dealerId = dealerContext?.id;
          const dealerMarket = dealerContext?.market;
          dispatch(setDealerContext({ dealerContextId: dealerId, dealerMarket }));
        }
      },
    );
    return (): void => {
      if (dealerContextService) {
        unsubscribeDealerContext();
      }
    };
  }, [dealerContextService, dispatch]);

  // Set config to redux
  useEffect(() => {
    if (!remoteConfig) return;

    dispatch(setConfig(remoteConfig));
  }, [dispatch, remoteConfig]);

  // useEffect(() => {
  //   console.log('location seach isHidden: ', remoteConfig);
  //   if (!remoteConfig) return;
  //   const config = remoteConfig?.__type === 'aem-headless' ? content : remoteConfig;
  //   console.log('🚀 ~ useEffect ~ config:', config);

  //   dispatch(setConfig(config));
  // }, [dispatch, remoteConfig, content]);
  return (
    <AudiPlatformProvider>
      <I18nextProvider i18n={i18n}>
        {/* @ts-ignore */}
        <ErrorBoundary>
          <ThemeProvider theme={COLORS}>
            <ApolloProvider client={apolloClient}>
              <div className="resetWrapper">
                <ContentWrapper />
              </div>
            </ApolloProvider>
            <GlobalStyles />
          </ThemeProvider>
        </ErrorBoundary>
      </I18nextProvider>
    </AudiPlatformProvider>
  );
};

export default FeatureApp;
